<template>
    <div>
        <div id="profile" v-if="authInfo">
            <div class="profile_header">
                <div class="profile_avatar">
                    <span>{{this.authInfo.first_name.substring(0, 1)}}</span>
                </div>
                <div class="profile_name">
                <h3>{{this.authInfo.first_name}} {{this.authInfo.last_name}}</h3>
                <p>{{this.authInfo.phone}}</p>
                </div>
            </div>           
            <div class="profile_main">
                <h2>{{text('profile.title')}}</h2>
                <div class="profile_main_contact">
                  <div class="profile_block">
                      <h4>{{text('profile.email')}}</h4>
                      <p>{{this.authInfo.email}}</p>
                  </div>
                  <div class="profile_block">
                      <h4>{{text('profile.phone')}}</h4>
                      <p>{{this.authInfo.phone}}</p>
                  </div>
                  <div class="profile_block">
                      <h4>{{text('profile.register_date')}}</h4>
                      <p>{{formatDateTime(this.authInfo.registered_at)}}</p>
                  </div>
                </div>
                <div class="mt-6">
                  <BaseButton dark @click="logout()" suffix>
                    <template #label>
                      {{ text('profile.logout') }}
                    </template>
                    <template #suffix>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                      >
                        <path
                            opacity="0.4"
                            d="M10.2621 4.04211V3.34236C10.2621 1.81611 9.0246 0.578613 7.49835 0.578613H3.8421C2.3166 0.578613 1.0791 1.81611 1.0791 3.34236V11.6899C1.0791 13.2161 2.3166 14.4536 3.8421 14.4536H7.50585C9.0276 14.4536 10.2621 13.2199 10.2621 11.6981V10.9909"
                            stroke="white"
                            stroke-width="1.125"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M15.3569 7.51599H6.32617"
                            stroke="white"
                            stroke-width="1.125"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M13.1611 5.32971L15.3571 7.51596L13.1611 9.70296"
                            stroke="white"
                            stroke-width="1.125"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                      </svg>
                    </template>
                  </BaseButton>
                </div>
            </div>
            <div class="profile_main">
                <h2>{{text('profile.identification.title')}}
                    <span style="font-weight: bold; float: right;">
                        <IconInfo v-if="textData('kyc.identification_level.help') || emptyDataTextHardCode"  @click="showInfoAlert" />
                    </span>
                </h2>
                <div class="profile_main_contact">
                    <div class="profile_block">
                        <h4>{{ text('profile.identification.level.title' )}}</h4>
                        <p>{{ identificationLevel }}</p>
                    </div>
                    <div class="profile_block" v-if="this.authInfo.identification_level?.ask_for_next && !this.authInfo.active_identification">
                        <h4></h4>
                        <div>
                          <BaseButton @click="identification_level_upgrade()">
                            <template #label>{{text('profile.identification.upgrade_btn')}}</template>
                          </BaseButton>
                        </div>
                    </div>
                    <div class="profile_block" v-if="this.authInfo.active_identification">
                        <h4>{{text('profile.identification.upgrade.status') }}</h4>
                        <p>{{this.authInfo.active_identification?.status}}</p>                    
                    </div>
                    <div class="profile_block" v-if="this.authInfo.active_identification && this.authInfo.active_identification.status !== 'aborted' && this.authInfo.active_identification.status !== 'complete'">
                        <h4></h4>
                        <div>
                          <BaseButton @click="identification_level_status()">
                            <template #label>{{text('profile.identification.refresh_status_btn')}}</template>
                          </BaseButton>
                        </div>
                    </div>
                    <div class="profile_block" v-if="this.authInfo.active_identification && this.authInfo.active_identification.status === 'aborted'">
                        <h4></h4>
                        <div>
                          <BaseButton @click="identification_level_upgrade()">
                            <template #label>{{text('profile.identification.retry_upgrade_btn')}}</template>
                          </BaseButton>
                        </div>
                    </div>
                </div>
            </div>     
            <TextModal
                @closeModal="textModalActive = false"
                v-if="textModalActive"
                title=""
                :text="textData('kyc.identification_level.help') || emptyDataTextHardCode"
            />
            <TextModal
                @closeModal="identificationLevelUpgradeHelpActive = false"
                v-if="identificationLevelUpgradeHelpActive"
                title=""
                :text="identificationLevelUpgradeHowtoText"
            />

            <GrokPolicy v-if="envName === 'grok'" />
            <StaterPolicy v-else-if="envName === 'stater'" />
            <ArvandPolicy v-else-if="envName === 'arvand'" />
            <div v-else-if="envName === 'cmp'" style="margin-top: 20px">
              <CMPPolicy />
            </div>
        </div>

        <!-- 
        <div id="qr_code">
            <div class="qr_img">
                <img class="qr_main_img" src="@/assets/images/qr_code.png" alt="">
                <img class="qr_avatar" src="@/assets/images/avatar.svg" alt="">
            </div>
            <div class="qr_name">
                <h4>{{text('profile.qr.title')}}</h4>
                <p>{{text('profile.qr.share')}}</p>
                <button class="qr_btn" download>
                    {{text('profile.qr.download')}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                        <path opacity="0.4" d="M12.1067 5.26575C11.7681 5.26575 11.3196 5.25825 10.7611 5.25825C9.39926 5.25825 8.27946 4.131 8.27946 2.75625V0.34425C8.27946 0.1545 8.12723 0 7.93936 0H3.97327C2.12203 0 0.625 1.5195 0.625 3.38175V11.463C0.625 13.4168 2.19332 15 4.12772 15H10.0342C11.8795 15 13.375 13.4902 13.375 11.6265V5.60325C13.375 5.41275 13.2235 5.259 13.0349 5.25975C12.7178 5.262 12.3376 5.26575 12.1067 5.26575" fill="#C7FF24"/>
                        <path opacity="0.4" d="M10.063 0.425405C9.83877 0.192155 9.44727 0.352655 9.44727 0.675905V2.65366C9.44727 3.48316 10.1298 4.16566 10.9593 4.16566C11.4828 4.17166 12.2088 4.17316 12.8253 4.17166C13.141 4.17091 13.3015 3.79366 13.0825 3.56566C12.2913 2.74291 10.8745 1.26841 10.063 0.425405" fill="#C7FF24"/>
                        <path d="M9.32954 8.03163C9.11054 7.81488 8.75804 7.81338 8.53904 8.03313L7.34729 9.23088V5.61063C7.34729 5.30238 7.09679 5.05188 6.78854 5.05188C6.48029 5.05188 6.22979 5.30238 6.22979 5.61063V9.23088L5.03729 8.03313C4.81904 7.81338 4.46579 7.81488 4.24754 8.03163C4.02854 8.24913 4.02854 8.60238 4.24529 8.82138L6.39254 10.9784H6.39329C6.44429 11.0294 6.50504 11.0706 6.57329 11.0991C6.64079 11.1269 6.71429 11.1419 6.78854 11.1419C6.86354 11.1419 6.93704 11.1269 7.00454 11.0984C7.07129 11.0706 7.13204 11.0294 7.18304 10.9791L7.18454 10.9784L9.33104 8.82138C9.54854 8.60238 9.54854 8.24913 9.32954 8.03163" fill="#C7FF24"/>
                    </svg>    
                </button>
            </div>
        </div>
        -->
        <!-- <QrPay /> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GrokPolicy from '../components/GrokPolicy.vue';
import StaterPolicy from '../components/StaterPolicy.vue';
import ArvandPolicy from '../components/ArvandPolicy.vue';
import CMPPolicy from '../components/CMPPolicy.vue';
import QrPay from '@/components/QrPay.vue'
import IconInfo from '../components/icons/IconInfo.vue';
import TextModal from '../components/TextModal.vue';
import { identificationLevelUpgrade, identificationLevelStatus } from '../services/api'
import BaseButton from '@/components/base/buttons/BaseButton.vue'

export default {
    name: "Settings",
    components: {
        QrPay,
        GrokPolicy,
        IconInfo,
        TextModal,
        StaterPolicy,
        ArvandPolicy,
        CMPPolicy,
        BaseButton
    },
    data() {
        return {
            textModalActive: false,
            identificationLevelUpgradeHelpActive: false,
            identificationLevelUpgradeHowtoText: '',
        }
    },
    mounted () {
        // const redirectHome = () => {
        //     if (this.$route.name === 'Settings') {
        //         if (window.screen.width > 920) {
        //             this.$router.push({name: 'Home'})
        //         }
        //     }
        // }

        // redirectHome();

        // window.addEventListener('resize', function () {
        //     redirectHome();
        // })
    },
    computed: {
        ...mapGetters([
            'textData'
        ]),
        emptyDataTextHardCode() {
          const { lang } = this.$store.state

          if (lang !== 'en') {
            return `<div><strong>Уровни идентификации</strong></div><br/>
              <div>
                Уровень идентификации определяет, какие возможности будут доступны при использовании кошелька:
              </div>
              <ul>
                <li>
                  лимиты на платежи и переводы;
                </li>
                <li>
                  максимальный остаток на балансе;
                </li>
                <li>
                  перечень доступных операций.
                </li>
              </ul>
              <div>Наш кошелёк предусматривает два уровня идентификации:</div> <br/>
              <div><strong>Неидентифицированный</strong></div>
              <ul>
                <li>
                  Платежи и переводы — до 15 000 ₽ в месяц
                </li>
                <li>
                  Лимит одной операции — до 15 000 ₽
                </li>
              </ul>
              <div><strong>Полностью идентифицированный</strong></div>
              <ul>
                <li>
                  Платежи и переводы — до 1 000 000 ₽ в месяц
                </li>
                <li>
                  Лимит одной операции — до 300 000 ₽
                </li>
              </ul>`
          } else {
            return false
          }
        },
        authInfo () {
            return this.$store.state.authInfo
        },
        authToken () {
            return this.$store.state.authToken
        },
        identificationLevel() {
          return this.authInfo.identification_level?.name
        }
    },
    created() {
        this.$store.dispatch('refreshAuthInfo')
        this.$store.dispatch('refreshTextData')
    }, 
    methods: {
        logout () {
            this.$store.commit('logout')
            this.$router.push({name: 'AuthIn'})
        },
        async identification_level_status() {
            const response = await identificationLevelStatus(this.authToken)
            console.log(response)
            window.location.reload()
        },
        async identification_level_upgrade() {
            const response = await identificationLevelUpgrade(this.authToken)
            if (response.verification_url) {
                window.location = response.verification_url
            } else {
                this.identificationLevelUpgradeHowtoText = response.howto_text
                this.identificationLevelUpgradeHelpActive = true
            }
        },
        showInfoAlert() {
            this.textModalActive = true
        }   
    }
};
</script>